/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get_inline_address } from "../../utils/data";
import { formatTime } from "../utils";

import AccordionContainer from "../../shared/components/AccordionContainer.vue";

const __vue_script__ = {
  name: "TripDetail",
  components: { AccordionContainer },
  props: ["doc"],
  data() {
    return {
      show: false,
    };
  },
  computed: {
    driverAddress() {
      if (!this.doc.driver_address) return "";
      return get_inline_address(this.doc.driver_address);
    },
    departure_time() {
      return formatTime(this.doc.departure_time);
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("accordion-container", { staticClass: "py-5" }, [
    _c("div", { staticClass: "card text-dark border mb-3" }, [
      _c("div", { staticClass: "card-header", on: { click: _vm.toggle } }, [
        _c("strong", [
          _vm._v("\n        Details\n        "),
          _vm.show
            ? _c("svg", { staticClass: "icon icon-sm" }, [
                _c("use", {
                  staticClass: "mb-1",
                  attrs: { href: "#icon-up-line" }
                })
              ])
            : _c("svg", { staticClass: "icon icon-sm" }, [
                _c("use", {
                  staticClass: "mb-1",
                  attrs: { href: "#icon-down" }
                })
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.show
        ? _c("div", { staticClass: "card-body" }, [
            _c("p", [
              _vm._v("\n        Driver: "),
              _c("strong", [_vm._v(_vm._s(_vm.doc.driver_name))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Vehicle: "),
              _c("strong", [_vm._v(_vm._s(_vm.doc.vehicle))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Driver Address: "),
              _c("strong", [_vm._v(_vm._s(_vm.driverAddress))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Departure Time: "),
              _c("strong", [_vm._v(_vm._s(_vm.departure_time))])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-935ea2aa_0", { source: "\n.card-header[data-v-935ea2aa] {\n  cursor: pointer;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/TripDetail.vue"],"names":[],"mappings":";AAgEA;EACA,eAAA;AACA","file":"TripDetail.vue","sourcesContent":["<template>\n  <accordion-container class=\"py-5\">\n    <div class=\"card text-dark border mb-3\">\n      <div class=\"card-header\" @click=\"toggle\">\n        <strong>\n          Details\n          <svg class=\"icon icon-sm\" v-if=\"show\">\n            <use class=\"mb-1\" href=\"#icon-up-line\"></use>\n          </svg>\n          <svg class=\"icon icon-sm\" v-else>\n            <use class=\"mb-1\" href=\"#icon-down\"></use>\n          </svg>\n        </strong>\n      </div>\n      <div class=\"card-body\" v-if=\"show\">\n        <p>\n          Driver: <strong>{{ doc.driver_name }}</strong>\n        </p>\n        <p>\n          Vehicle: <strong>{{ doc.vehicle }}</strong>\n        </p>\n        <p>\n          Driver Address: <strong>{{ driverAddress }}</strong>\n        </p>\n        <p>\n          Departure Time: <strong>{{ departure_time }}</strong>\n        </p>\n      </div>\n    </div>\n  </accordion-container>\n</template>\n<script>\nimport { get_inline_address } from \"../../utils/data\";\nimport { formatTime } from \"../utils\";\n\nimport AccordionContainer from \"../../shared/components/AccordionContainer.vue\";\n\nexport default {\n  name: \"TripDetail\",\n  components: { AccordionContainer },\n  props: [\"doc\"],\n  data() {\n    return {\n      show: false,\n    };\n  },\n  computed: {\n    driverAddress() {\n      if (!this.doc.driver_address) return \"\";\n      return get_inline_address(this.doc.driver_address);\n    },\n    departure_time() {\n      return formatTime(this.doc.departure_time);\n    },\n  },\n  methods: {\n    toggle() {\n      this.show = !this.show;\n    },\n  },\n};\n</script>\n\n<style scoped>\n.card-header {\n  cursor: pointer;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-935ea2aa"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/TripDetail.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__